"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PromoCodeTemplatesLocalesEdit_1 = require("./PromoCodeTemplatesLocalesEdit");
var PromoCodeTemplatesLocalesList_1 = require("./PromoCodeTemplatesLocalesList");
var PromoCodeTemplateLocalisations = /** @class */ (function (_super) {
    __extends(PromoCodeTemplateLocalisations, _super);
    function PromoCodeTemplateLocalisations(props) {
        return _super.call(this, props) || this;
    }
    PromoCodeTemplateLocalisations.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AL = this.props.listAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ availLanguage: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availLanguage: []
        }, function () {
            _this.props.listAppLanguages.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Промокоды", "Локализации шаблонов промокодов"]);
    };
    PromoCodeTemplateLocalisations.prototype.componentWillUnmount = function () {
        this.props.listAppLanguages.UnSubscribe(this.SID_AL);
    };
    PromoCodeTemplateLocalisations.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    PromoCodeTemplateLocalisations.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PromoCodeTemplateLocalisations.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PromoCodeTemplateLocalisations.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PromoCodeTemplateLocalisations.prototype.getBrandLocalisationRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PromoCodeTemplatesLocalesEdit_1.default, { state: this.props.state, data: this.props.dataLocales, record: this.state.record, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PromoCodeTemplatesLocalesEdit_1.default, { state: this.props.state, data: this.props.dataLocales, record: this.state.record, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PromoCodeTemplatesLocalesList_1.default, { state: this.props.state, data: this.props.dataLocales, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    PromoCodeTemplateLocalisations.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandLocalisationRenderObject()));
    };
    return PromoCodeTemplateLocalisations;
}(React.Component));
exports.default = PromoCodeTemplateLocalisations;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/locales/PromoCodeTemplateLocalisations.tsx
// module id = 1963
// module chunks = 0